var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer",class:{hid: _vm.config.gallery}},[_c('div',{staticClass:"bg-gray"},[_c('div',{staticClass:"wrapper"},[_c('FooterLaboratorio')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }